import { useEffect, useContext, useMemo } from "preact/hooks";
import { gql, useMutation, useQuery } from "@apollo/client";

import useLocalStorageState from "use-local-storage-state";
import CREATE_CHECKOUT_MUTATION from "@/mutations/createCheckout";
import { GlobalContext } from "@/context/GlobalContext";
import CHECKOUT_FRAGMENT from "@/fragments/checkout";
import FETCH_CART_QUERY from "@/queries/fetchCartQuery";

const useCart = () => {
	const { checkout, setCheckout } = useContext(GlobalContext);
	const { cartItemCount, setCartItemCount } = useContext(GlobalContext);
	const [retailerObject, setRetailerObject] = useLocalStorageState("dutchie_retailer");
	const retailerId = retailerObject?.id;
	const retailerSlug = retailerObject?.slug;
	const [checkoutId, setCheckoutId] = useLocalStorageState("dutchie_checkout_" + retailerSlug);
	const [orderType, setOrderType] = useLocalStorageState('cp_fulfillment_type');

	const calculateCartTotal = (checkout) => {
		let total = 0;
		checkout.items.forEach((item) => {
			total += item.quantity;
		});

		setCartItemCount(total);
	};

	const {
		loading: cartLoading,
		error: cartError,
		data: cartData,
	} = useQuery(FETCH_CART_QUERY, {
		variables: {
			checkoutId: checkoutId,
			retailerId: retailerId
		},
		skip: !retailerId,
		onCompleted(cartData) {
			calculateCartTotal(cartData.checkout);
			setCheckout(cartData.checkout); 
		},
	});

	const [
		createCheckoutMutation,
		{ loading: checkoutLoading, error: checkoutError, data: checkoutData },
	] = useMutation(CREATE_CHECKOUT_MUTATION, {
		variables: {
			retailerId,
			orderType: orderType ? orderType : "PICKUP",
			pricingType: "RECREATIONAL",
		},
	});

	useEffect(
        function createCheckoutIfNotFound() {
            async function createCheckout() {
                const checkout = await createCheckoutMutation();
                setCheckoutId( checkout.data.createCheckout.id );
            }

            // Create a new checkout if loading one was unsuccessful
            if (cartError) {
                createCheckout();
            }
        }, [createCheckoutMutation, cartError] 
    );

	return { cartLoading, cartError, checkoutId, setCheckoutId };
};
export default useCart;
